export const CREATE_TABLE = 'CREATE_TABLE'
export const GET_HOLIDAYS= 'GET_HOLIDAYS'
export const SET_HOLIDAYS= 'SET_HOLIDAYS'
export const COUNT_HOLIDAYS= 'COUNT_HOLIDAYS'

